import useInterpolateUrl from 'modules/interaction/hooks/useInterpolateUrl'
import useIframe from 'modules/shared/hooks/useIframe'
import Iframe from 'modules/shared/Iframe'
import { useEffect } from 'react'

type ActivityEmbeddedSitemodelProps = {
  sitemodelUuid: string
  urlSiteRenderer: string
  customQueryString?: string
}

const ActivityEmbeddedSitemodel = ({
  sitemodelUuid,
  urlSiteRenderer,
  customQueryString
}: ActivityEmbeddedSitemodelProps) => {
  const interpolateUrl = useInterpolateUrl()

  const queryString = 'token={{TOKEN}}&lang={{LANGUAGE}}'
  const finalQueryString = customQueryString
    ? `${queryString}&${customQueryString}`
    : queryString

  const iframeSrc = interpolateUrl(
    `${urlSiteRenderer}/${sitemodelUuid}?${finalQueryString}`
  )
  const { iframeAttributes, receiveMessage } = useIframe({
    origin: urlSiteRenderer,
    src: iframeSrc,
    title: 'SiteRenderer'
  })

  useEffect(() => {
    window.addEventListener('message', receiveMessage)
    return () => window.removeEventListener('message', receiveMessage)
  }, [receiveMessage])

  if (!iframeAttributes) {
    return null
  }

  return <Iframe {...iframeAttributes} />
}

export default ActivityEmbeddedSitemodel
